import { useGalleryData } from 'Components/Gallery';
import { GalleryPreview, Placeholder } from 'Components/Gallery/GalleryPreview';
import type { GalleryImageWithTitle } from 'Components/Gallery/MainGallery/MainGallery';
import { ExLeaseBadge } from 'Components/shared/ExLeaseBadge';
import { MobilizeBadge } from 'Components/shared/MobilizeBadge';
import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import {
	triggerGalleryOpenEvent,
	triggerHeroImageClickedEvent,
	triggerHeroImageViewedEvent,
	triggerHeroNextButtonClickedEvent,
	triggerHeroPrevButtonClickedEvent,
	triggerHeroThumbClickedEvent,
} from 'Services/analytics/events/galleryEventsRedesign';
import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';

import { useGalleryTrigger } from '../../Components/GalleryProvider';

import styles from './VehiclePhotosSection.module.scss';

export const VehiclePhotosSection: React.FC = () => {
	const { images } = useGalleryData();
	const openGallery = useGalleryTrigger();
	const vehicle = useVehicleData();
	const isExLease = useFeatureToggle(FEATURES.exLeaseBranding);
	const isMobilizeVehicle = vehicle.sourcePartner?.toLowerCase() === 'mobilize';
	const isExLeaseVehicle = isExLease && vehicle.seller?.isTrade && !isMobilizeVehicle;

	const handleOnClick = ({ id, kind }: GalleryImageWithTitle) => {
		triggerHeroImageClickedEvent({ kind });
		openGallery({ id });
		triggerGalleryOpenEvent({ kind });
	};

	const getPreviewBadge = () => {
		if (isMobilizeVehicle) return <MobilizeBadge size="large" />;
		if (isExLeaseVehicle) return <ExLeaseBadge size="large" />;
		return undefined;
	};

	return (
		<div className={styles.preview}>
			{images.length ? (
				<>
					<GalleryPreview
						events={{
							onClick: handleOnClick,
							onNext: triggerHeroNextButtonClickedEvent,
							onPrev: triggerHeroPrevButtonClickedEvent,
							onSlideView: triggerHeroImageViewedEvent,
							onThumbClick: triggerHeroThumbClickedEvent,
						}}
						images={images}
						overlayBadge={getPreviewBadge()}
					/>
					<div className={styles.thumbnailBadge}>
						{isMobilizeVehicle && <MobilizeBadge />}
						{isExLeaseVehicle && <ExLeaseBadge />}
					</div>
				</>
			) : (
				<Placeholder />
			)}
		</div>
	);
};
